export default () => /* GraphQL */ `
    mutation SetSelected($listId: ID!) {
        lists: setSelected(listId: $listId) {
            listId
            name
        }
    }
`;
